import PropTypes from 'prop-types'

export default PropTypes.shape({
   customPages: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
   })),
   id: PropTypes.string,
   initiativeTypes: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      class: PropTypes.string.isRequired,
      description: PropTypes.string,
      enabled: PropTypes.bool.isRequired,
      nameSingular: PropTypes.string.isRequired,
      namePlural: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
   })),
   logoDefault: PropTypes.shape({
      thumbnailUrl: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number
   }),
   name: PropTypes.string,
   privacy: PropTypes.string,
   tagline: PropTypes.string
})
